module.exports = __webpack_public_path__ + "img/stripe-stencil.6b54b71a.svg";